import Environment from "./Environment";

export const TOKENS = [
    { NAME: "GEMS", tokenImg: "gems", tokenAddress: Environment.gems, decimals: 18 },
    { NAME: "ETH", tokenImg: "eth", tokenAddress: Environment.ETH, decimals: 18 },
    { NAME: "USDT", tokenImg: "usdt", tokenAddress: Environment.USDT, decimals: 6 },
    { NAME: "USDC", tokenImg: "usdc", tokenAddress: Environment.USDC, decimals: 6 },
    { NAME: "TOMI", tokenImg: "tomi", tokenAddress: Environment.TOMI, decimals: 18 }, // Could not reliably determine decimals
    { NAME: "WBTC", tokenImg: "wbtc", tokenAddress: Environment.WBTC, decimals: 8 },
    { NAME: "LINK", tokenImg: "link", tokenAddress: Environment.LINK, decimals: 18 },
    { NAME: "PEPE", tokenImg: "pepe", tokenAddress: Environment.PEPE, decimals: 18 },
    { NAME: "UNI", tokenImg: "uni", tokenAddress: Environment.UNI, decimals: 18 },
    // { NAME: "DOP", tokenImg: "   dop", tokenAddress: Environment.DOP, decimals: 18 },
];

// make a variable where i send chain id and it give me chain name
export const CHAIN_IDS = {
    1: "Ethereum",
    8453: "Base",
    56: "Binance Smart Chain",
    137: "Polygon",
    42161: "Arbitrum",
    43114: "Avalanche",
};


// // Projects data array
// export const projectsData = [
//     {
//         id: 1,
//         name: "Chainers",
//         symbol: "$CHU",
//         description: "Chainers is a multi-genre gaming universe that blends a player-owned Web3 economy with classic...",
//         logo: "\\assets\\alldetailpages\\chainers\\main-img.png",
//         link: "/chainers",
//         saleType: "comingsoon",
//         verified: true,
//         notifyName: "CHAINERS",
//     },
//     {
//         id: 2,
//         name: "Screx",
//         symbol: "SCRX",
//         description: "Screx aims to provide a unified and intelligent environment for decentralized finance (DeFi), allowing users...",
//         logo: "\\assets\\alldetailpages\\screx\\screxlogo.svg",
//         link: "/screx",
//         saleType: "live",
//         verified: true,
//         round: "04",
//         currentPrice: "$0.05",
//         totalRaised: "--",
//         startTime: 1762493520000,
//         endTime: 1763125200000,
//         buyLink: "http://buyscrex.gems.vip/",
//     },
//     {
//         id: 3,
//         name: "Luckify",
//         symbol: "$LUCK",
//         description: "Luckify is redefining the world of chance-based gaming by putting fairness on-chain. From casino-style games...",
//         logo: "\\assets\\alldetailpages\\luckify\\luckify-logo.svg",
//         link: "/luckify",
//         saleType: "ended",
//         initialPrice: 0.05,
//         totalRaised: "$1,100,000+",
//         blockchain: "binance-smart-chain",
//         contractAddress: "0x5bc247A5fc7DC148b682787C58f6f764ce27581b",
//     },
//     {
//         id: 4,
//         name: "Matchain",
//         symbol: "Genesis License",
//         description: t('Cre83'),
//         logo: "\\assets\\alldetailpages\\matchain\\banner\\token-logo.svg",
//         link: "/matchain",
//         saleType: "ended",
//         initialPrice: 250,
//         totalRaised: "$260,000",
//         athLabel: "All Time High",
//     },
//     {
//         id: 5,
//         name: "Astra Nova",
//         symbol: "$RVV",
//         description: t('Cre84'),
//         logo: "\\assets\\alldetailpages\\astra\\banner\\token-logonew.png",
//         link: "/astranova",
//         saleType: "ended",
//         initialPrice: 0.005,
//         totalRaised: "$1,650,000",
//         blockchain: "binance-smart-chain",
//         contractAddress: "0x80563Fc2dd549bf36f82d3bF3b970Bb5b08dBDdb",
//     },
//     {
//         id: 6,
//         name: "Rain",
//         symbol: "$RAIN",
//         description: t('Cre85'),
//         logo: "\\assets\\alldetailpages\\miners\\otherprojects\\rain-token.png",
//         link: "/rain",
//         saleType: "ended",
//         initialPrice: 0.0003875,
//         totalRaised: "$1,900,000+",
//         blockchain: "arbitrum-one",
//         contractAddress: "0x25118290e6A5f4139381D072181157035864099d",
//     },
//     {
//         id: 7,
//         name: "Olympus AI",
//         symbol: "OAI",
//         description: t('Cre86'),
//         logo: "\\assets\\presaletokens\\olympus.png",
//         link: "/olympus",
//         saleType: "ended",
//         initialPrice: 0.1,
//         totalRaised: "$2,100,000",
//         roundLabel: t('Process-t13'),
//     },
//     {
//         id: 8,
//         name: "LEIA",
//         symbol: "LEIA",
//         description: t('Cre87'),
//         logo: "\\assets\\presaletokens\\leia.png",
//         link: "/leia",
//         saleType: "ended",
//         initialPrice: 0.0001,
//         totalRaised: "$3,300,000+",
//         blockchain: "ethereum",
//         contractAddress: "0x9F24818c84B357Ee05CFB2F2c1537C73c7Cb1502",
//     },
//     {
//         id: 9,
//         name: "Incentiv",
//         symbol: "CENT",
//         description: t('Cre88'),
//         logo: "\\assets\\presaletokens\\incentiv.png",
//         link: "/incentiv",
//         saleType: "ended",
//         initialPrice: 0.00325,
//         totalRaised: "$25,000,000+",
//     },
//     {
//         id: 10,
//         name: "Gems",
//         symbol: "Gems",
//         description: t('Cre89'),
//         logo: "\\assets\\alldetailpages\\gemsdetailpage\\info\\token-logo.png",
//         link: "/gemsdetail",
//         saleType: "ended",
//         initialPrice: 0.07,
//         totalRaised: "$10,000,000+",
//         blockchain: "ethereum",
//         contractAddress: "0x3010ccb5419F1EF26D40a7cd3F0d707a0fa127Dc",
//     },
//     {
//         id: 11,
//         name: "DOP",
//         symbol: "DATA OWNERSHIP PROTOCOL",
//         description: t('Cre90'),
//         logo: "\\assets\\presaletokens\\dop.png",
//         link: "/dopdetail",
//         saleType: "ended",
//         initialPrice: 0.01,
//         totalRaised: "$160,000,000+",
//         blockchain: "ethereum",
//         contractAddress: "0xa37DB5456b5938Aa50B33575Ae2eB8048CA5959b",
//     },
//     {
//         id: 12,
//         name: "NFA",
//         symbol: "NFA",
//         description: t('Cre91'),
//         logo: "\\assets\\alldetailpages\\nfa\\token-logo.png",
//         link: "/nfa",
//         saleType: "ended",
//         initialPrice: 0.0234,
//         totalRaised: "$289,000+",
//     },
// ];